import { Box, Button, Typography } from '@mui/material';
import { Stack } from '@mui/material';
import DashboardNavbar from '../../Components/DashboardNavbar/DashboardNavbar';
import { useNavigate } from 'react-router-dom';

function PlaceHolder(props) {

    const navigate = useNavigate();

    return (
        <Box>
            <DashboardNavbar userType='student' />
            <Stack spacing={2} sx={{ minWidth: 80, p: 2, mx: 10, alignItems: 'center', justifyContent: 'center' }}>
                <Typography variant='h4'>This page is not available yet!</Typography>
                <Typography variant='body'>Since this is the beta version of this application, some features are still in development.</Typography>
                <Typography variant='body'>If you would like to go back press the button below:</Typography>
                <Button variant="contained" color='primary' onClick={() => navigate(-1)}>Go Back</Button>
            </Stack>
        </Box>
    );
}

export default PlaceHolder;